export default __webpack_public_path__ + "static/media/vendimia.4acea3ff.jpeg";